import { DataLandingPage } from '/src/pages/landingPages/dataLandingPages/DataLandingPage';
import { REGION_IDS, TAXONOMIES } from '/src/lib/constants';
import { INVESTMENT_VEHICLES } from '/src/lib/constants/investmentVehicles';



/* data-specific landing pages */
export const dataLandingPageRoutes = [

    // type 1: region-specific

    {
        id: 101,
        path: '/mena-data',
        component: DataLandingPage,
        type: 'region',
        region_id: REGION_IDS.mena,
        map_type: 'mena',
        dataType: "MENA",
        hubspotFormSource: 'sales_mena'
    },
    {
        id: 102,
        path: '/africa-data',
        component: DataLandingPage,
        type: 'region',
        region_id: REGION_IDS.africa,
        map_type: 'africa',
        dataType: "Africa",
        hubspotFormSource: 'sales_africa'
    },
    {
        id: 103,
        path: '/southeast-asia-data',
        component: DataLandingPage,
        type: 'region',
        region_id: REGION_IDS.southeastAsia,
        map_type: 'southeast_asia',
        dataType: "Southeast Asia",
        hubspotFormSource: 'sales_southeast_asia'
    },

    // type 2: investment type data

    {
        id: 201,
        path: '/vc-investment-data',
        component: DataLandingPage,
        type: 'investment_type',
        investment_type_id: [TAXONOMIES.fundingStage],
        map_type: 'magnitt_focus_regions',
        dataType: "VC Investment",
        hubspotFormSource: 'sales_vc'
    },
    {
        id: 202,
        path: '/pe-investment-data',
        component: DataLandingPage,
        type: 'investment_type',
        investment_type_id: [TAXONOMIES.peFundingStage],
        map_type: 'magnitt_focus_regions',
        dataType: "PE Investment",
        hubspotFormSource: 'sales_pe'
    },
    {
        id: 203,
        path: '/venture-debt-data',
        component: DataLandingPage,
        type: 'investment_type',
        investment_vehicle_id: [INVESTMENT_VEHICLES.ventureDebt, INVESTMENT_VEHICLES.lineOfCredit],
        map_type: 'magnitt_focus_regions',
        dataType: "Venture Debt",
        hubspotFormSource: 'sales_venture_debt'
    },

    // type 3 combo
    // sales_region_datatype

]